var render = function render(){var _vm=this,_c=_vm._self._c;return _c('title-wrapper',{attrs:{"title":_vm.$t('components.catalog.title')}},[_c('catalog-list'),_c('v-row',{staticClass:"mt-3"},[_c('v-spacer'),_c('v-col',{staticClass:"text-right"},[_c('primary-button',{attrs:{"onClick":_vm.goFoward}},[_vm._v(_vm._s(_vm.$t('components.catalog.summary')))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }